(function attachCommercePricing(global) {
  'use strict';

  function isInternationalPath(pathname) {
    var path = String(pathname || '').split('?')[0];
    return /^\/(?:en|es)-international(?:\/|$)/.test(path);
  }

  function rehydrateCartItems(items, catalog) {
    if (!Array.isArray(items)) return [];
    var currentCatalog = catalog || {};

    return items.reduce(function hydrate(acc, item) {
      var product = item && currentCatalog[item.id];
      if (!product) return acc;

      var priceUsd = Number(product.priceUsd);
      var pricePen = Number(product.pricePen);
      if (!Number.isFinite(priceUsd) || !Number.isFinite(pricePen)) return acc;

      acc.push(Object.assign({}, item, {
        priceUsd: priceUsd,
        pricePen: pricePen
      }));
      return acc;
    }, []);
  }

  global.MACommerce = Object.freeze({
    isInternationalPath: isInternationalPath,
    rehydrateCartItems: rehydrateCartItems
  });
})(window);
